// extracted by css-extract-rspack-plugin
export default {"HighlightedText":"HighlightedText_HighlightedText__sTR9f"};